// packages/content/src/catalog/fruit.ts — `sell` is ignored: rules/economy prices native vs foreign from tuning.shop (Contract change 1)
import type { CatalogEntry } from '../schema/catalog';
export default [
  { id: 'fruit.apple', kind: 'fruit', name: 'nature.apple', sell: 100, stack: 10, fruit: 'apple' },
  { id: 'fruit.orange', kind: 'fruit', name: 'nature.orange', sell: 100, stack: 10, fruit: 'orange' },
  { id: 'fruit.pear', kind: 'fruit', name: 'nature.pear', sell: 100, stack: 10, fruit: 'pear' },
  { id: 'fruit.peach', kind: 'fruit', name: 'nature.peach', sell: 100, stack: 10, fruit: 'peach' },
  { id: 'fruit.cherry', kind: 'fruit', name: 'nature.cherry', sell: 100, stack: 10, fruit: 'cherry' },
] as const satisfies readonly CatalogEntry[];
